<script>
	import {USER} from '../store.js'
	import {onMount} from 'svelte'
	import {createEventDispatcher} from 'svelte'
	import {API,http_headers,SPINNER} from '../global.js'
	import Filtro from './filtro.svelte'
	import Comentarios from './comentarios.svelte'

	import {CLIENTE} from '../store.js'

	const dispatch = createEventDispatcher()
	let loading = false

	export let idcliente= 0
	let rpp=15

	let where = " 1=1 "
	let filtro = ""

  	let estado_elegido = ""
	let anioActual = (new Date).getFullYear()

	let datos = []


	let verComentarios = false

	function set_cliente(cli){
		CLIENTE.set(cli)
		close()
	}

	function close(){
		dispatch('close')
	}

	function dias(fecha){
		let laFecha = (new Date(fecha)).valueOf()
		let hoy = (new Date()).valueOf()
		let diferencia = parseInt((hoy - laFecha)/1000/60/60/24)
		if(diferencia>999) return 999
		else return diferencia
	}


	const refresh = async () => {
		loading=true
		let where = " 1=1 " + (filtro.anterior!=='' ? ` and ${filtro.anterior} ` : '') +
				(filtro.actual!=='' ? ` and ${filtro.actual} ` : '') +
				(filtro.actualsfp!=='' ? ` and ${filtro.actualsfp} ` : '') +
				(filtro.siguiente!=='' ? ` and ${filtro.siguiente} ` : '') +
				(filtro.dsc!=='' ? ` and ${filtro.dsc}${filtro.cantdias} ` : '') +
				(filtro.estados.length>0 ? ` and cc.estado in (${filtro.estados.map(v=>"'"+v+"'")}) ` : '' )
		localStorage.setItem('__cartera__',JSON.stringify(filtro))

		let res = await fetch(`${API}/cartera/${filtro.idejecutivo}?idhotel=${filtro.idhotel}&page=${filtro.page}&rpp=${rpp}&where=${where}`)
		const ds = await res.json()
		loading = false
		datos =  ds || []

	}

	async function getEjecutivos(){
		let rs = await fetch(`${API}/usuarios?activo=1&rpp=999`)
		let ds = await rs.json()
		return ds.data || []
	}

	function moveToPage(pag){
		filtro.page += pag
		refresh()
	}

	function prevpage(){
		filtro.page-=filtro.page>0?1:0
		refresh()
	}

	function nextpage(){
		filtro.page+=!datos.eof?1:0
		refresh()
	}

	let cliente = {}
	function abrirComentarios(itm){
		cliente = itm
		verComentarios=true
	}

	async function cerrarComentarios(ev){
		if(ev.detail.cb==='refresh') {
			refresh()
		}
		if(ev.detail.cb==='save'){
			let item = ev.detail.item

			// { id, idcliente, idhotel, estado, lastupdate, comentario }

			await guardar(item)
		}
		cliente = {}
		verComentarios = false
	}

	async function guardar_estado(itm){
		let timestamp = (new Date).toLocaleString()
		let user = $USER.username
		let formateado = `###  ${user} ${timestamp} ###
'Cambio de estado'

${itm.comentario||''}
`
		let item = {
					id: itm.idcomment||0,
					idcliente: itm.idcliente,
					idhotel: itm.idhotel,
					estado: estado_elegido,
					comentario: formateado
				}
		await guardar(item)
		estado_elegido = ''

	}

	const guardar = async (params) => {
		console.log(params)
		let id = params.id
		delete params.id
		let rs = await fetch(`${API}/cartera-actualizar/${id}`,{
	        method:'POST',
	        headers: http_headers,
	        body: JSON.stringify(params)
	    })

		let ds = await rs.json()
		console.log(ds)
		refresh()
	}

	onMount( async () => {
		idcliente = $CLIENTE
		let f = localStorage.getItem('__cartera__') || '{"anterior":"","actual":"","actualsfp":"","siguiente":"","dsc":"", "cantdias":30 , "estados":[], "page":0, "idejecutivo":0, "idhotel":0}'
		filtro = JSON.parse(f)
		refresh()
	})

	let hoteles = ['','RDA','RDE']
</script>

<div class="flotante-derecha border clearfix shadow rounded-sm">
	<span class="btn float-end btn-danger btn-sm m-1" on:click="{close}">&Cross;</span>

	{#if !loading}
	<div class="container-fluid mt-2 overflow-auto" style="max-height:90vh;">

		<p>
			<Filtro bind:filtro={filtro} on:refresh={refresh}/>
		</p>
		{#if  datos.success}
			<nav aria-label="Page navigation example">
			  <ul class="pagination pagination-sm ms-4">
			    <li class="page-item">
			      <a class="page-link" on:click={()=>moveToPage(-filtro.page)} href={"#"}>&laquo;</a>
			    </li>
			    <li class="page-item">
			      <a class="page-link" on:click={prevpage} href={"#"}>&lt;</a>
			    </li>
			    <li class="page-item"><a class="page-link" href={"#"}>{filtro.page}</a></li>
			    <li class="page-item">
			      <a class="page-link" href={"#"} on:click={nextpage}>&gt;</a>
			    </li>
			    <li class="page-item">
			      <a class="page-link" on:click={()=>moveToPage(10)} href={"#"}>&raquo;</a>
			    </li>
			  </ul>

			</nav>
			<table class="table table-striped table-sm">
				<thead>
					<tr>
						<th>Cliente</th>
						<th>Nombre</th>
						<th>Hotel</th>
						<th class="numero pe-4">Anter.</th>
						<th class="numero pe-4">{anioActual}</th>
						<th class="numero pe-4">{anioActual}(sfp)</th>
						<th class="numero pe-4">{anioActual+1}</th>
						<th class="numero pe-4">{anioActual+1}(sfp)</th>
						<th class="numero pe-4" title="Dias desde ultimo contacto">dsc</th>
						<th>Stat</th>
						<th>&nbsp;

						</th>
					</tr>
				</thead>
				<tbody>
				{#each datos.data as item, index}
					<tr>
						<td class="target" style="background-color:#{item.estado};" on:click={()=>set_cliente(item.idcliente)}>{item.idcliente}</td>
						<td style="background-color:#{item.estado};">{item.nombre}</td>
						<td style="background-color:#{item.estado};" class="hotel{item.idhotel}">{hoteles[item.idhotel||0]}</td>
						<td style="background-color:#{item.estado};" class="numero px-4">{(item.saldo_sub_3+item.saldo_sub_2+item.saldo_sub_1).toFixed(2)}</td>
						<td style="background-color:#{item.estado};" class="numero px-4">{item.saldo_add_0.toFixed(2)}</td>
						<td style="background-color:#{item.estado};" class="numero px-4">{item.saldosfp_add_0.toFixed(2)}</td>
						<td style="background-color:#{item.estado};" class="numero px-4">{item.saldo_add_1.toFixed(2)}</td>
						<td style="background-color:#{item.estado};" class="numero px-4">{item.saldosfp_add_1.toFixed(2)}</td>
						<td style="background-color:#{item.estado};" class="numero">{dias(item.lastupdate)}</td>
						<td style="background-color:#{item.estado};" class="numero px-4">
							<select bind:value={estado_elegido} class="form-select-sm" on:change={()=>guardar_estado(item)}>
								<option value="">&nbsp;&nbsp;</option>
								<option style="background-color:#FFFFFF;" value="FFFFFF">&nbsp;&nbsp;</option>
								<option style="background-color:#00CCFF;" value="00CCFF">&nbsp;&nbsp;</option>
								<option style="background-color:#CCFF00;" value="CCFF00">&nbsp;&nbsp;</option>
								<option style="background-color:#FFB300;" value="FFB300">&nbsp;&nbsp;</option>
								<option style="background-color:#FF00CC;" value="FF00CC">&nbsp;&nbsp;</option>
							</select>
						</td>
						<td><span class="btn btn-sm btn-secondary" on:click={()=>abrirComentarios(item)}><i class="bi-file-earmark-pdf"></i></span></td>
					</tr>
				{/each}
				</tbody>
			</table>

		{/if}
	</div>
	{:else}
		<p>Loading....</p>
	{/if}

</div>

{#if verComentarios}
		<Comentarios {cliente} on:close={cerrarComentarios}/>
{/if}

<style>
	.numero{ text-align: right; }
	.hotel1{ color:green }
	.hotel2{ color:blue }
	.target{ cursor: pointer;}
	.target:hover{ font-weight: bolder;}
</style>

<!--
exports.cartera = async (req, res) => {
	let page = req.query.page || 0
	let rpp = req.query.rpp || RPP
	let where = " 1=1 "
	let idejecutivo = req.params.idejecutivo || 0
	let idhotel = req.query.hotel || 0
	let filtro = req.query.filtro || ''

	if(parseInt(idhotel>0) where += ` and c.idhotel = ${parseInt(idhotel)} `
	if(parseInt(idejecutivo)>0) where += ` and c.idejecutivo = ${parseInt(idejecutivo)} `
	where += filtro


	let query = `select t.* from (
				    select
				      row_number() over(order by c.idcliente) rn,
				      c.idcliente,c.nombre,c.nrointercambio,c.idejecutivo,c.idejecutivoventa,
				      c.idvendedor,c.idhotel, c.saldo_sub_3,c.saldo_sub_2,c.saldo_sub_1,
				      c.saldo_add_0,c.saldosfp_add_0,
				      c.saldo_add_1,c.saldosfp_add_1,
				      c.email,isnull(cc.id,0) idcomment,isnull(cc.estado,'FFFFFF') estado,cc.lastupdate,comentario
				    from cartera c
				      left join comentariosCartera cc on cc.idcliente=c.idcliente and cc.idhotel=c.idhotel
				    where ${where}
				) t
				where t.rn between ((${page}*${rpp})+1) and ((${page}+1)*${rpp})
				order by t.idcliente,t.idhotel`
	try {
		const rs = await knex.raw(query)

		let count = rs.length || 0
		let eof = (count < rpp) || false
		let data = rs || []
		res.status(201).json({success:true,err:'',page,count,eof,data})
	} catch (err) {
		res.status(401).json({ success:false, err:err.message||'', data:[] })
	}
}
-->
